import Vue from 'vue';
import {
  getStoreDealer, getStores, getIndexSa, getIndexCustomer, getIndexReservation, getStorePersonnel, updateSa, changeMemberSa, getPersonnelStore
 } from '../../../services/personnelService/sicService';
 // initial state
 // state 必為模組區域變數，取時需 store.state.auth.user
 // 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
 // 區域使用時值需加上 name
const _ = require('lodash');

const state = {
  storeData: [],
  storeDealer: [],
  stores: [],
  storeInfo: null,
  personnel: [],
  pagination: {
    current_page: 0,
    per_page: 5
  },
  storePersonnel: [],
  personnelStoreData: [],
};

 // getters
 const getters = {};

 // actions
const actions = {
  // 經銷商列表
  async getStoreDealerHandler({ commit }) {
    const data = await getStoreDealer();
    commit('setStoreDealer', data);
  },
  // 取得區經理底下的店舖
  async getStoresHandler({ commit }, storeInfo) {
    const data = await getStores(storeInfo);
    commit('setStores', data);
  },
  // 取得店鋪BA預約
  async getIndexSaHandler({ commit }, storeInfo) {
    const query = Object.keys(storeInfo).map(key => `${key}=${storeInfo[key]}`).join('&');

    const data = await getIndexSa(query);
    commit('setStoreData', data);
  },
  // 取得店鋪顧客預約
  async getIndexCustomerHandler({ commit }, storeInfo) {
    const query = Object.keys(storeInfo).map(key => `${key}=${storeInfo[key]}`).join('&');

    const data = await getIndexCustomer(query);
    commit('setStoreData', data);
  },
  // 取得所有顧問
  async getAllSaHandler({ commit }, storeInfo) {
    const query = Object.keys(storeInfo).map(key => `${key}=${storeInfo[key]}`).join('&');
    const data = await getIndexSa(query);
    commit('setPersonnelData', data);
  },
  // 取得店鋪預約
  async getIndexReservationHandler({ commit }, storeInfo) {
    const data = await getIndexReservation(storeInfo);
    commit('setStoreData', data);
  },
  // 取得顧問列表
  async getStorePersonnelHandler({ commit }, { sa_id, store_id }) {
    const data = await getStorePersonnel(store_id);
    commit('setStorePersonnel', { data, sa_id });
  },
  // 更改顧問狀態
  async updateSaHandler({}, updateInfo) {
    await updateSa(updateInfo);
  },
  // 更換顧客的顧問
  async changeMemberSaHandler({}, updateInfo) {
    await changeMemberSa(updateInfo);
  },
  // 取得Sic管理的店舖
  async getPersonnelStoresHandler({ commit }) {
    const data = await getPersonnelStore();
    commit('setPersonnelStore', { data });
  },
};

// mutations
const mutations = {
  setStoreData(state, data) {
    if (data.data.personnel) {
      Vue.set(state, 'storeData', state.storeData.concat(data.data.personnel));
    } else if (data.data.members) {
      Vue.set(state, 'storeData', state.storeData.concat(data.data.members));
    } else if (data.data.reservations) {
      Vue.set(state, 'storeData', state.storeData.concat(data.data.reservations));
    } else {
      Vue.set(state, 'storeData', []);
    }
    Vue.set(state, 'storeInfo', data.data.store);
    Vue.set(state, 'pagination', data.pagination);
  },
  setPersonnelData(state, data) {
    Vue.set(state, 'personnel', data.data.personnel);
  },
  setStoreDealer(state, data) {
    Vue.set(state, 'storeDealer', data.data.dealer);
  },
  setStores(state, data) {
    Vue.set(state, 'stores', data.data.stores);
  },
  // 重置所有資料
  resetHandler(state) {
    Vue.set(state, 'storeData', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 5
    });
    Vue.set(state, 'storeInfo', null);
  },
  setStorePersonnel(state, { data, sa_id }) {
    Vue.set(state, 'storePersonnel', []);
    _.forEach(data.data.personnel, (val) => {
      if (val.sa_id === sa_id) {
        state.storePersonnel.push({
          $isDisabled: true,
          ...val
        });
      } else {
        state.storePersonnel.push(val);
      }
    });
  },
  setPersonnelStore(state, data) {
    Vue.set(state, 'personnelStoreData', data.data.data.stores);
  }
};

 export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations
 };
